import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import Label from 'components/form/Label/Label';
import * as PropTypes from 'prop-types';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SmallModal } from 'components/Modals/SmallModal';
import { Button } from 'components/form/Button';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useSeenModulePixel } from 'hook/helper.hook';

const CardShippingAddress = props => {
  const { addressLine, city, region, postalCode } =
    props.sesameCashAccount.address;
  const fullAddress = `${addressLine} ${city} ${region} ${postalCode}`;

  const seenPixel = useSeenModulePixel({
    'Module Name': 'Sesame Cash Card Delivery Address',
  });

  return (
    <SectionContainer>
      {seenPixel}
      <Row className="margB16">
        <FlexContainer className="flex-row justify-start">
          <Label className="text-28 bold m-text-20">
            Card Shipment Details
          </Label>
          <FlexContainer
            onClick={props.onClickShippingHelpIcon}
            className="justify-center align-self-center pointer margL12"
          >
            <QuestionCircleOutlined />
          </FlexContainer>
        </FlexContainer>
      </Row>
      <Row className="text-16 ">DELIVERING TO: {fullAddress}</Row>
      <SmallModal
        visible={props.showShippingHelpModal}
        onCancel={props.onCloseShippingHelpModal}
        footer={
          <>
            <FlexContainer className="justify-end flex-row mob-flex-column">
              <Button
                datatestid="close-shipping-help-modal"
                mrphType="link"
                onClick={props.onCloseShippingHelpModal}
              >
                Close
              </Button>
              <Button
                datatestid="start-chat-shipping-help-modal"
                mrphType="primary"
                onClick={props.onClickStartShippingChat}
              >
                Start Chat
              </Button>
            </FlexContainer>
          </>
        }
      >
        <Row className="padLR0 margB16">
          <Label className="text-36 m-text-24 bold">
            Your card is on the way
          </Label>
        </Row>
        <Row className="text-16 padLR0 margB16">
          Your card will arrive in 7-10 business days to the address on your
          profile. If this address is incorrect, please contact our customer
          care team.
        </Row>
      </SmallModal>
    </SectionContainer>
  );
};

CardShippingAddress.propTypes = {
  modulePosition: PropTypes.number.isRequired,
  sesameCashAccount: PropTypes.object.isRequired,
  onClickShippingHelpIcon: PropTypes.func.isRequired,
  showShippingHelpModal: PropTypes.bool.isRequired,
  onCloseShippingHelpModal: PropTypes.func.isRequired,
  onClickStartShippingChat: PropTypes.func.isRequired,
};

export default CardShippingAddress;
